import { redirect } from "react-router"
import { Dispatch } from "redux"

import { Api } from "api"
import { AccountingOfficeStageEnum } from "enums"
import { AccountingOffice } from "types/AccountingOffice"
import { ResultModel } from "types/ApiResponse"
import { PromiseAction } from "types/RemoteAction"

export const fetchAccountingOfficeAction =
  () =>
  (dispatch: Dispatch): PromiseAction<ResultModel<AccountingOffice>> =>
    dispatch({
      type: "accountingOffice/FETCH",
      promise: Api.fetchAccouningOffice()
    })

export const moveNextStageAction = () => async (dispatch: Dispatch) => {
  try {
    await Api.moveNextStage()
    const res = await Api.fetchAccouningOffice()

    if (
      res.result.accountingOfficeConfigurationStage ===
      AccountingOfficeStageEnum.Done
    ) {
      dispatch({
        type: "accountingOffice/SET_VALUE",
        resolved: "SET_VALUE",
        payload: {
          field: "accountingOfficeConfigurationStage",
          value: "Done"
        }
      })
    }
  } catch (err) {
    console.error("Error:", err)
  } finally {
    redirect("/")
  }
}
